import { render, staticRenderFns } from "./PimplesTemplate.vue?vue&type=template&id=2264abbd"
import script from "./PimplesTemplate.vue?vue&type=script&lang=js"
export * from "./PimplesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports